import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

var state = {
    token: null,
    user: {},
    menuExpand: false,  // 左侧菜单是否收起
    accessKey: false, // 是否acckey方式登录
    accessKeyUrl: null, // accessKeyUrl
    inIframe: false, // 是否在iframe中
    isPhone: false, // 是否手机访问
    menuDisp: true, // 左侧菜单是否显示
    menuTrademarkDisp: true, // 左侧菜单商标是否显示
    headerDisp: true, // 顶部是否显示
    logOutDisp: true, // 退出登录是否显示
    showTip: true,      // 初次登录提示
    showTableClickTip: true,     // 点击表格切换详情提示
    dataDictionary:[],
    menuArray: [],
    lang: '',
    licenceHasExpired: false
}

var mutations = {
    set_token(state, token) {
        state.token = token;
    },
    del_token(state) {
        state.token = '';
    },
    set_user(state, user){
        state.user = user;
    },
    set_menuArray(state, menuArray) {
        state.menuArray = menuArray;
    },
    change_menuExpand(state) {
        state.menuExpand = !state.menuExpand;
    },
    set_accessKey(state, status) {
        state.accessKey = status;
    },
    set_accessKeyUrl(state, url) {
        state.accessKeyUrl = url;
    },
    set_inIframe(state, status) {
        state.inIframe = status;
    },
    set_isPhone(state, status) {
        state.isPhone = status;
    },
    set_menuDisp(state, status) {
        state.menuDisp = status;
    },
    set_menuTrademarkDisp(state, status) {
        state.menuTrademarkDisp = status;
    },
    set_headerDisp(state, status) {
        state.headerDisp = status;
    },
    set_logOutDisp(state, status) {
        state.logOutDisp = status;
    },
    close_showTip(state) {
        state.showTip = false;
    },
    set_dictionary(state, dataList) {
      state.dataDictionary = dataList;
    },
    set_lang(state, lang) {
        state.lang = lang;
    },
    set_licenceHasExpired(state, licenceHasExpired) {
        state.licenceHasExpired = licenceHasExpired;
    }
}

const store = new Vuex.Store({
    state,
    mutations:mutations
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js